export const CACHE_KEY_LIST_NOMENCLATURES_COMPANIES = 'nomenclatures-companies';
export const CACHE_KEY_NOMENCLATURES_COMPANIES = 'nomenclatures-companies-one';
export const ROUTE_PATH_NOMENCLATURES_COMPANIES = '/settings/nomenclatures/companies';
export const TRANSLATION_PREFIX_NOMENCLATURES_COMPANIES = 'nomenclaturesCompanies';

